export default __webpack_public_path__ + "static/ml-3-2f2b6880a03b212ba571f6a2bed05c3a.png";